import * as colors from 'constants/colors'
// or use this for color themes
// import colors from './colorsTheme'

// just to show warning for non-existing colors
const handler = {
  get: function (target, name) {
    if (!target[name] && name[0] !== '@' && name[0] !== '_' && name[0] !== '$') {
      console.warn(`Requested color "${name}" does not exist.`)
    }
    return target[name]
  },
}
const colorsProxy = new Proxy(colors, handler)

export default colorsProxy
